import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { authRef } from '../reference';

// HOC to inject navigate function
function withNavigate(Component) {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

class Landing extends Component {
  componentDidMount() {
    this.unsubscribe = onAuthStateChanged(authRef, user => {
      if (user) {
        this.props.navigate('/home');
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  render() {
    return (
      <div className="Landing">
      </div>
    );
  }
}

export default withNavigate(Landing);
